
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stocks/[stockSlug]/technical-analysis",
      function () {
        return require("private-next-pages/stocks/[stockSlug]/technical-analysis/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stocks/[stockSlug]/technical-analysis"])
      });
    }
  